export enum WorkflowStageStatus {
  COMPLETED = 'completed',
  IN_PROGRESS = 'inProgress',
  PENDING = 'pending',
  IN_REVIEW = 'inReview',
}

export enum WorkflowStageStatusText {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'In Progress',
  PENDING = 'Pending',
  IN_REVIEW = 'In Review',
}

export enum SchemaItemStatus {
  SCHEMA_ITEM_COMPLETED = 'schemaItemCompleted',
  SCHEMA_ITEM_DISABLED = 'schemaItemDisabled',
  SCHEMA_ITEM_IN_REVIEW = 'schemaItemInReview',
  SCHEMA_ITEM_AVAILABLE = 'schemaItemAvailable',
}
